import { render, staticRenderFns } from "./NotificationItem.vue?vue&type=template&id=91f94f32&scoped=true"
import script from "./NotificationItem.vue?vue&type=script&lang=ts"
export * from "./NotificationItem.vue?vue&type=script&lang=ts"
import style0 from "./NotificationItem.vue?vue&type=style&index=0&id=91f94f32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f94f32",
  null
  
)

export default component.exports